// Function to style usernames in comment text that start with @username
export const styleUsernamesInComment = (htmlContent: string): string => {
  if (htmlContent.startsWith('@')) {
    // First try to match HTML with mention links: @<a class="mention-link" href="...">Username</a>:
    if (htmlContent.includes('<a class="mention-link"')) {
      return htmlContent.replace(/^(@<a class="mention-link"[^>]*>[^<]+<\/a>:)/, '<span style="color: var(--chakra-colors-dune-700)">$1</span>');
    }
    // Otherwise match plain text: @username:
    else {
      return htmlContent.replace(/^(@\w+:)/, '<span style="color: var(--chakra-colors-dune-700)">$1</span>');
    }
  }
  return htmlContent;
};